export default __webpack_public_path__ + "static/media/minniemuse.06026a97.svg";